module.exports = __webpack_public_path__ + "img/teacher_02.dc2f4123.png";